import { produce } from 'immer';

import { UpdateInternalProductPlaces } from '../../../actions/places/internal/updateInternalProductPlaces';
import { InternalProductPlacesState } from '../../../typings/internalProductPlace';

export function updateInternalProductPlaces(
    state: InternalProductPlacesState,
    action: UpdateInternalProductPlaces
): InternalProductPlacesState {
    return produce(state, draft => {
        draft.places = action.places;
    });
}
